export function getFirstValueOfObject(obj: any): any {
  const values = Object.values(obj);
  if (values.length > 0) {
    return values[0];
  } else {
    return undefined; // or handle the case where the object is empty
  }
}
